import { inject, observer } from 'mobx-react'
import React from 'react'
import ExportKMZTooltip from 'components/common/tooltips/ExportKMZTooltip'
import { withTranslation } from 'react-i18next'
import { startProCheckout } from '../../../proCheckout'
import ProBadge from '../ProBadge'
import { HugeiconsIcon } from '@hugeicons/react'
import { FileCodeIcon } from '@hugeicons/core-free-icons'

const ExportKmzButton = ({ disabled, uiStore, lgIcon, t, item }) => {
  const isStarter = uiStore.user && uiStore.user.type === 'starter'
  const isDisabled = disabled && !isStarter

  return (
    <button
      className={`export-kmz-btn nooutline export-kmz ${isStarter ? 'item-controls__disabled' : ''}`}
      disabled={isDisabled}
      onClick={(e) => {
        e.stopPropagation()
        if (isStarter) {
          startProCheckout({ uiStore, t })
          return
        }
        uiStore.kmlFormat = false
        uiStore.openClickTooltip({
          style: {
            width: 360
          },
          position: 'right-start',
          selector: '.tools.popup-menu',
          text: (<ExportKMZTooltip item={item} />)
        })
      }}
    >
      <HugeiconsIcon icon={FileCodeIcon} size={18} className='popup-menu__icon' />
      <span>{t('GLOBAL.EXPORT_KML', { defaultValue: 'Export KML/KMZ' })}</span>
      {isStarter && <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
    </button>
  )
}

export default withTranslation()(inject('uiStore')(observer(ExportKmzButton)))
